import { pushProductClick, pushPromotionClick } from '@v4/common/utils/data-layer';

export default {
    methods: {
        pushPromotionClickToDataLayer(vehicle, cb) {
            if (!vehicle) {
                return;
            }

            pushPromotionClick(
                {
                    id: vehicle.promotionId,
                    name: vehicle.subtitle,
                    position: vehicle.position,
                },
                cb
            );
        },
        pushProductClickToDataLayer(vehicle, actionField = null, cb) {
            let products = [];

            if (Array.isArray(vehicle)) {
                products = vehicle;
            } else {
                products.push(vehicle);
            }

            products = products
                .filter((item) => item)
                .map((item) => ({
                    name: item.model || item.submodelCommercialName,
                    id: item.submodelId,
                    price: item.finalPriceRaw || item.originalPriceRaw,
                    brand: item.make || item.makeName,
                    category: item.segment,
                    variant: item.vehicleId,
                    position: item.position,
                    quantity: 1,
                }));

            if (products.length) {
                pushProductClick(products, actionField, cb);
            }
        },
    },
};
